import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../../../environments/environment';
import {ISchedule} from '../worship';

@Injectable()
export class SchedulesService {

    constructor(
        private _http: HttpClient,
    ) {
    }

    list(): Observable<ISchedule[]> {
        return <any>this._http.get(`${environment.api}/worship/schedules`);
    }

    one(scheduleId: number): Observable<ISchedule> {
        return <any>this._http.get(`${environment.api}/worship/schedules/${scheduleId}`);
    }

    save(schedule: ISchedule): Observable<ISchedule> {
        if (!!schedule.id) {
            return this.edit(schedule);
        }
        return this.add(schedule);
    }

    add(schedule: ISchedule): Observable<ISchedule> {
        return <any>this._http.post(`${environment.api}/worship/schedules`, this.makeRequestFrom(schedule));
    }

    edit(schedule: ISchedule): Observable<ISchedule> {
        return <any>this._http.put(`${environment.api}/worship/schedules/${schedule.id}`, this.makeRequestFrom(schedule));
    }

    archive(schedule: ISchedule): Observable<ISchedule> {
        return <any>this._http.delete(`${environment.api}/worship/schedules/${schedule.id}`);
    }

    remove(schedule: ISchedule): Observable<ISchedule> {
        const options = {
            params: {persistent: 'true'}
        };
        return <any>this._http.delete(`${environment.api}/worship/schedules/${schedule.id}`, options);
    }

    notifyTeam(schedule: ISchedule): Observable<ISchedule> {
        return <any>this._http.put(`${environment.api}/worship/schedules/${schedule.id}/notify`, {});
    }

    private makeRequestFrom(schedule: ISchedule) {
        const request = JSON.parse(JSON.stringify(schedule));
        request.songs = request.songs.map(s => s.id);
        return request;
    }
}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/worship/schedules/schedules.service.ts